import { useContext } from 'react';
import {
  CANNOT_DELETE_DEVICE_BODY,
  CANNOT_DELETE_DEVICE_TITLE,
} from 'src/common/constants/localizations/devices';
import { LocationAndLocalizationContext } from '../../../providers/LocationAndLocalizationProvider';
import css from '../account-settings.module.scss';

const CannotDeleteDeviceContent = () => {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);

  return (
    <div className="row">
      <div className="col-xs-12">
        <div className={css.contentTitle} data-testid="cannotDeleteDeviceTitle">
          {getLocalizedText(CANNOT_DELETE_DEVICE_TITLE)}
        </div>
        <p data-testid="cannotDeleteDeviceBody" className={css.contentBodyText}>
          {getLocalizedText(CANNOT_DELETE_DEVICE_BODY)}
        </p>
      </div>
    </div>
  );
};

export default CannotDeleteDeviceContent;
